(function(){
    AuthReports.$inject = ['$scope', '$location', 'toastr', '__env', 'readCookie'];

    angular
        .module('app')
        .component('authReportsComponent', {
            templateUrl: 'modules/reports/components/authReports/authReports.html',
            controller: AuthReports
        });

    /**
     * Functionality for the portal grid
     *
     * @class PortalGrid
     * @param { service } $scope - The scope of the controller.
     * @param { service } $location - The Angular $location service.
     * @param { service } toastr - The third party toaster service.
     * @param { service } __env - The environment configuration.
     */

    function AuthReports($scope, $location, toastr, __env, readCookie){

        $scope.$parent.pageTitle = 'Report Management';

        /**
         * provides a new current date in yyyy-mm-dd format
         *
         * @function
         * @return { string } - current date in yyyy-mm-dd format
         */
    	$scope.getCurrentDate = function() {
        	var current = new Date();
        	var dateString = current.getFullYear() + '-' + current.getMonth() + '-' + current.getDate();

        	return dateString;
        };

    	// column properties for the kendo grid
    	var sessionColumns = [

    	        {
    	            field: 'email',
    	            title: 'Email',
    	            width: '100px'
    	        },
    	        {
    	            field: 'expiryUtc',
    	            title: 'Session Expires (UTC)',
    	            width: '100px',
    	            template: '#= kendo.toString(kendo.parseDate(expiryUtc), "yyyy-MM-dd h:mm tt") #'
    	        },
    	        {
    	            field: 'sessionKey',
    	            title: 'Session Key',
    	            width: '100px'
    	        }
    	    ];

        // model kendo uses to bind the data to the grid
    	var sessionModel = { id: 'userId',
    	                fields: {
    	                    'email': { type: 'string' },
    	                    'expiryUtc': { type: 'string' },
    	                    'sessionKey': { type: 'string' }
    	                }};

        // kendo grid options for the Portal grid
        $scope.sessionOptions = {
            columnMenu: true,
            columns: sessionColumns,
            editable: 'inline',
            excel: {
                    fileName: 'Session-' +  $scope.getCurrentDate() + '.xlsx',
                    filterable: true
                },
            filterable: {
                extra: false,
                operators: {
                    string: {
                        contains: 'Contains',
                        eq: 'Is equal to'
                    }
                }
            },
            groupable: false,
            pageable: true,
            scrollable: true,
            selectable: false,
            sortable: true,
            toolbar: ['excel']
        };


        // kendo data source for the Portal Grid
    	$scope.sessionSource = {
            type: 'aspnetmvc-ajax',
            error: function(e) { toastr.error('Could not get session data for the report. Please \'report\' this error.');},
    		transport: {
    			read: {
    				type: 'get',
    				contentType: 'application/json',
    				url: __env.apiBaseUrlReport + 'session',
                    beforeSend: function(req) {
                        req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
                        req.setRequestHeader('Authorization','Bearer ' + readCookie.getByName(__env.authCookieName));
                    },
    			},

    		},
    		schema: {
                data: 'data',
                total: 'total',
                model: sessionModel,
            },
            pageSize: 20,
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true,
            sort: {
                field: 'expiryUtc',
                dir: 'desc'
            }
    	};



    	/****************** USER AUDIT REPORT **************************************************/

    	// column properties for the kendo grid
    	var userAuditColumns = [

    	        {
    	            field: 'email',
    	            title: 'Email',
    	            width: '75px'
    	        },
    	        {
    	            field: 'portalName',
    	            title: 'Portal Name',
    	            width: '75px'
    	        },
    	        {
    	        	field: 'userAuditType',
    	        	title: 'Audit Type',
    	        	width: '75px'
    	        },
    	        {
    	            field: 'message',
    	            title: 'Message',
    	            width: '50px'
    	        },
    	        {
    	            field: 'auditTimeUtc',
    	            title: 'Audit Time (UTC)',
    	            width: '100px',
    	            template: '#= kendo.toString(kendo.parseDate(auditTimeUtc), "yyyy-MM-dd h:mm tt") #'
    	        }
    	    ];

        // model kendo uses to bind the data to the grid
    	var userAuditModel = { id: 'userAuditId',
    	                fields: {
    	                    'email': { type: 'string' },
    	                    'portalName': { type: 'string' },
    	                    'userAuditType': { type: 'string' },
    	                    'message': { type: 'string' },
    	                    'auditTimeUtc': { type: 'date' }
    	                }};

        // kendo grid options for the Portal grid
        $scope.userAuditOptions = {
            columnMenu: true,
            columns: userAuditColumns,
            editable: 'inline',
            excel: {
                    fileName: 'User-Audit-' + $scope.getCurrentDate() + '.xlsx',
                    filterable: true
                },
            filterable: {
                extra: false,
                operators: {
                    string: {
                        contains: 'Contains',
                        eq: 'Is equal to'
                    }
                }
            },
            groupable: false,
            pageable: true,
            scrollable: true,
            selectable: false,
            sortable: true,
            toolbar: ['excel']
        };


        // kendo data source for the Portal Grid
    	$scope.userAuditSource = {
        	type: 'aspnetmvc-ajax',
            error: function(e) { toastr.error('Could not get user audit data for the report. Please \'report\' this error.');},
    		transport: {
    			read: {
    				type: 'get',
    				contentType: 'application/json',
    				url: __env.apiBaseUrlReport + 'useraudits',
                    beforeSend: function(req) {
                        req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
                        req.setRequestHeader('Authorization','Bearer ' + readCookie.getByName(__env.authCookieName));
                    },
    			},

    		},
    		schema: {
                data: 'data',
                total: 'total',
                model: sessionModel,
            },
            pageSize: 20,
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true,
            sort: {
                field: 'auditTimeUtc',
                dir: 'desc'
            }
    	};


    };
})();